import React, { useEffect } from "react";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import { CMS_ASSET_URL_BASE } from "../../../../config";
import styles from "./CustomizedTabs.module.scss";
import cx from "classnames";
import { adobeClickTracking } from "../../../../helpers/tracking";
import { useDispatch, useSelector } from "react-redux";
import { setCurrentTab } from "../../../../features/singleGroup/singleGroupSlice";

const AntTabs = withStyles({
  root: {
    backgroundColor: "transparent",
    border: "none",
    borderRadius: "3px",
    filter: " drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.11));",
    marginBottom: "30px",
  },
  flexContainer: {
    zIndex: 1,
    position: "relative",
    backgroundColor: "transparent",
    "@media (max-width:780px)": { flexDirection: "column!important" },
  },
  indicator: {
    backgroundColor: "#ba0c2f",
    height: "100%",
    zIndex: 0,
    display: "none",
  },
})((props) => <Tabs {...props} />);

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div role="tabpanel" hidden={value !== index} {...other}>
      {value === index && children}
    </div>
  );
}
const AntTab = withStyles(() => ({
  root: {
    textTransform: "uppercase",
    fontFamily: "Gotham-Bold",
    borderRight: "1px solid #e8e8e8",
    backgroundSize: "cover",
    backgroundPosition: "top",
    backgroundColor: "white",
    height: "70px",
    opacity: 1,
    "&:not($selected)": {
      backgroundImage: "none!important",
    },
    "&:last-child": {
      borderRight: "none",
      opacity: 1,
    },
    "&:hover": {
      opacity: 1,
    },
    "&$selected": {
      backgroundColor: "#BA0C2F",
      opacity: 1,
      color: "#ffffff",
    },
    "&:focus": {
      opacity: 1,
    },
    "& > span": {
      marginTop: 2,
    },
  },
  selected: {},
}))((props) => (
  <Tab
    {...props}
    style={
      props.bg?.path
        ? {
            backgroundImage: `url(${CMS_ASSET_URL_BASE}${props.bg?.path})`,
          }
        : {
            backgroundColor: props.featured === "true" ? "gold" : "",
            fontSize: props.featured === "true" ? "1.1em" : "",
            lineHeight: props.featured === "true" ? "1.1em" : "",
            color: props.featured === "true" ? "#000847" : "",
          }
    }
    // className={styles.featured}
  />
));
const useStyles = makeStyles(() => ({
  root: {
    flexGrow: 1,
  },
  tabBar: {
    backgroundColor: "transparent",
  },
}));

export default function CustomizedTabs({ tabs, activeTab, trackingTitle }) {
  const classes = useStyles();
  const { type } = useSelector((state) => state?.singleGroup);
  const [value, setValue] = React.useState(activeTab || tabs[0].label);
  const dispatch = useDispatch();
  const gamesType = type === "single" ? "Single Game" : "Group";
  const prop13 = `Washington Nationals: Tickets: Nationals Ticketfinder: ${gamesType} Tickets: ${trackingTitle}`;

  const handleChange = (event, newValue) => {
    adobeClickTracking({
      prop13,
      prop14: `${gamesType} Tickets: ${trackingTitle}: ${newValue} Click`,
    });

    setValue(newValue);
  };
  useEffect(() => {
    dispatch(setCurrentTab(value));

    return () => {
      dispatch(setCurrentTab(""));
    };
  }, [dispatch, value]);

  return (
    <div className={cx(classes.root, styles.body)}>
      <div className={classes.tabBar}>
        <AntTabs variant="fullWidth" value={value} onChange={handleChange}>
          {tabs?.map((tab) => (
            <AntTab
              value={tab.label}
              key={tab.id}
              label={tab.label}
              bg={tab.bg}
              featured={tab.featured}
            />
          ))}
        </AntTabs>
      </div>
      {tabs.map((tab, i) => (
        <TabPanel value={value} index={tab.label} key={tab.id}>
          {tab.desc && <h2 className={styles.desc}>{tab.desc}</h2>}
          {tab.comp}
        </TabPanel>
      ))}
    </div>
  );
}
